import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProcurementServices } from "./ProcurementService";
import { toast } from "react-toastify";
import { successAlert } from "../Global/GlobalSlice";
import { VendorServices } from "../Vendor/VendorService";
import success from "../success";

export const CreateMemoRequisition = createAsyncThunk(
  "vendors/CreateMemoRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.memo().CreateMemoRequisition(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateMemoRequisition = createAsyncThunk(
  "vendors/UpdateMemoRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.memo().UpdateMemoRequisition(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMemoRequisitions = createAsyncThunk(
  "vendors/GetMemoRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.memo().GetMemoRequisitions(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyMemoRequisitions = createAsyncThunk(
  "vendors/GetMyMemoRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.memo().GetEmployeeMemoRequisitions(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleMemoRequisition = createAsyncThunk(
  "vendors/GetSingleMemoRequisition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.memo().GetSingleMemoRequisition(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveMemoRequsition = createAsyncThunk(
  "vendors/ApproveMemoRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.memo().ApproveMemoRequisition(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineMemoRequsition = createAsyncThunk(
  "vendors/DeclineMemoRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const response = await ProcurementServices.memo().DeclineMemoRequisition(
      payload
    );
    if (response?.data?.successful === true) {
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
    }
    return response?.data;
  },
  (error, { rejectWithValue }) => {
    return rejectWithValue(error?.response?.data);
  }
);

export const EscalateMemoRequsition = createAsyncThunk(
  "vendors/EscalateMemoRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.memo().EscalateMemoRequisition(
        payload
      );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Requision
export const CreateProcRequsition = createAsyncThunk(
  "vendors/CreateProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().CreateProcRequsition(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateProcRequsition = createAsyncThunk(
  "vendors/UpdateProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().UpdateProcRequsition(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcRequisitions = createAsyncThunk(
  "vendors/GetProcRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetProcRequisitions(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetMyProcRequisitions = createAsyncThunk(
  "vendors/GetMyProcRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetMyProcRequisitions(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcBeneficiaries = createAsyncThunk(
  "procurement/GetProcBeneficiaries",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.procurement().GetBeneficiaries(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcDepartment = createAsyncThunk(
  "procurement/GetProcDepartment",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      // const response = await ProcurementServices.procurement().GetDepartments(
      //   payload
      // );
      const response = await VendorServices.vendor().GetVendorDepartmentSetUp(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleProcRequisitions = createAsyncThunk(
  "vendors/GetSingleProcRequisitions",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetSingleProcRequisition(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveProcRequsition = createAsyncThunk(
  "vendors/ApproveProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().ApproveProcRequisition(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveProcRequsitionBulk = createAsyncThunk(
  "vendors/ApproveProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().ApproveProcRequisitionBulk(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineProcRequsition = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const response =
      await ProcurementServices.procurement().DeclineProcRequisition(payload);
    if (response?.data?.successful === true) {
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
    }
    return response?.data;
  },
  (error, { rejectWithValue }) => {
    return rejectWithValue(error?.response?.data);
  }
);

export const DeleteProcRequsition = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().DeleteProcRequisition(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineProcRequsitionBulk = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().DeclineProcRequisitionBulk(
          payload
        );
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const NotifyProcRequsition = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().NotifyProcRequisition(payload);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcRequisitionWaivers = createAsyncThunk(
  "vendors/GetProcRequisitionWaivers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetProcRequisitionWaivers(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleProcRequisitionWaivers = createAsyncThunk(
  "vendors/GetSingleProcRequisitionWaivers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetSingleProcRequisitionWaivers(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveProcRequisitionWaiver = createAsyncThunk(
  "vendors/ApproveProcRequisitionWaiver",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().ApproveProcRequisitionWaiver(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        //setIsOpen(!isOpen);
        toast.error(response?.data?.statusMessage, {
          autoClose: true,
          style: { zIndex: 9999990 },
        });
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineProcRequisitionWaiver = createAsyncThunk(
  "vendors/DeclineProcRequisitionWaiver",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().DeclineProcRequisitionWaiver(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        //setIsOpen(!isOpen);
        toast.error(response?.data?.statusMessage, {
          autoClose: true,
          style: { zIndex: 9999990 },
        });
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateProcQuotation = createAsyncThunk(
  "vendors/CreateProcQuotation",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().CreateProQuotation(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateProcQuotationDelivery = createAsyncThunk(
  "vendors/CreateProcQuotationDelivery",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().CreateProQuotationDelivery(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateProcQuotation = createAsyncThunk(
  "vendors/UpdateProcQuotation",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().UpdateProQuotation(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcQuotations = createAsyncThunk(
  "vendors/GetProcQuotations",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetProcQuotationsWorkflow(
          payload
        );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetControlQuotations = createAsyncThunk(
  "vendors/GetControlQuotations",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetControlQuotations(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleProcQuotations = createAsyncThunk(
  "vendors/GetSingleProcQuotations",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetSingleProcQuotation(payload);
      // toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const SendQuotationPaymentTerms = createAsyncThunk(
  "vendors/SendQuotationPaymentTerms",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().SendQuotationPaymentTerms(
          payload
        );
      // toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateQuotationPaymentTerms = createAsyncThunk(
  "vendors/UpdateQuotationPaymentTerms",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().UpdateQuotationPaymentTerms(
          payload
        );
      // toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetPaymentTerms = createAsyncThunk(
  "vendors/GetPaymentTerms",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.procurement().GetPaymentTerms(
        payload
      );
      // toast.success(response?.data?.statusMessage);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveProcQuotation = createAsyncThunk(
  "vendors/ApproveProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().ApproveProcQuotation(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      } else {
        //setIsOpen(!isOpen);
        toast.error(response?.data?.statusMessage, {
          autoClose: true,
          style: { zIndex: 9999990 },
        });
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineProQuotation = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    const response =
      await ProcurementServices.procurement().DeclineProcQuotation(payload);
    // toast.success(response?.data?.statusMessage);
    if (response?.data?.successful === true) {
      dispatch(
        successAlert({
          message: response?.data?.statusMessage,
        })
      );
    } else {
      //setIsOpen(!isOpen);
      toast.error(response?.data?.statusMessage, {
        autoClose: true,
        style: { zIndex: 9999990 },
      });
    }
    return response?.data;
  },
  (error, rejectWithValue) => {
    return rejectWithValue(error?.response?.data);
  }
);

export const DeliveredProQuotation = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().DeliveredProcQuotation(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      success(response);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ConfirmProQuotation = createAsyncThunk(
  "vendors/DeclineProcRequsition",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().DeclineProcQuotation(payload);
      // toast.success(response?.data?.statusMessage);
      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//Delivery

export const GetProcDelivery = createAsyncThunk(
  "vendors/GetProcDelivery",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await ProcurementServices.procurement().GetProcDelivery(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetProcRequisitionDashboard = createAsyncThunk(
  "procurement/GetProcRequisitionDashboard",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await ProcurementServices.procurement().GetProcRequisitionDashboard();
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  procurement: "",
};

export const AppSlice = createSlice({
  name: "procurement",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(GetSingleProcRequisitions.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(GetSingleProcRequisitions.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          proc_req_data: action.payload,
        };
      })
      .addCase(GetSingleProcRequisitions.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });
    builder
      .addCase(CreateProcRequsition.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(CreateProcRequsition.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          proc_data: action.payload,
        };
      })
      .addCase(CreateProcRequsition.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });
    builder
      .addCase(ApproveProcRequsition.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(ApproveProcRequsition.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          proc_approval: action.payload,
        };
      })
      .addCase(ApproveProcRequsition.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(DeclineProcRequsition.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(DeclineProcRequsition.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          proc_declined: action.payload,
        };
      })
      .addCase(DeclineProcRequsition.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcRequisitionWaivers.pending, (state) => {
        return {
          ...state,
          isLoadingWaivers: true,
        };
      })
      .addCase(GetProcRequisitionWaivers.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingWaivers: false,
          isSuccessful: true,
          all_proc_waivers: action.payload,
        };
      })
      .addCase(GetProcRequisitionWaivers.rejected, (state, action) => {
        return {
          ...state,
          isLoadingWaivers: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetSingleProcRequisitionWaivers.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(GetSingleProcRequisitionWaivers.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          proc_waiver_data: action.payload,
        };
      })
      .addCase(GetSingleProcRequisitionWaivers.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcQuotations.pending, (state) => {
        return {
          ...state,
          isLoadingVendors: true,
        };
      })
      .addCase(GetProcQuotations.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          isSuccessful: true,
          all_proc_quotations: action.payload,
        };
      })
      .addCase(GetProcQuotations.rejected, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetControlQuotations.pending, (state) => {
        return {
          ...state,
          isLoadingVendors: true,
        };
      })
      .addCase(GetControlQuotations.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          isSuccessful: true,
          all_proc_quotations: action.payload,
        };
      })
      .addCase(GetControlQuotations.rejected, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetSingleProcQuotations.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(GetSingleProcQuotations.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          proc_quotation_data: action.payload,
        };
      })
      .addCase(GetSingleProcQuotations.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcRequisitions.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetProcRequisitions.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_proc_requisitions: action.payload,
        };
      })
      .addCase(GetProcRequisitions.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetMemoRequisitions.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetMemoRequisitions.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_memo_requisitions: action.payload,
        };
      })
      .addCase(GetMemoRequisitions.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetMyMemoRequisitions.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetMyMemoRequisitions.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_memo_requisitions: action.payload,
        };
      })
      .addCase(GetMyMemoRequisitions.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetSingleMemoRequisition.pending, (state) => {
        return {
          ...state,
          isSubmitting: true,
        };
      })
      .addCase(GetSingleMemoRequisition.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccessful: true,
          isSubmitting: false,
          memo_req_data: action.payload,
        };
      })
      .addCase(GetSingleMemoRequisition.rejected, (state, action) => {
        return {
          ...state,
          isSubmitting: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetMyProcRequisitions.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetMyProcRequisitions.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          all_proc_requisitions: action.payload,
        };
      })
      .addCase(GetMyProcRequisitions.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcBeneficiaries.pending, (state) => {
        return {
          ...state,
          isLoadingVendors: true,
        };
      })
      .addCase(GetProcBeneficiaries.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          isSuccessful: true,
          beneficiaries: action.payload,
        };
      })
      .addCase(GetProcBeneficiaries.rejected, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcDepartment.pending, (state) => {
        return {
          ...state,
          isLoadingVendors: true,
        };
      })
      .addCase(GetProcDepartment.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          isSuccessful: true,
          departments: action.payload,
        };
      })
      .addCase(GetProcDepartment.rejected, (state, action) => {
        return {
          ...state,
          isLoadingVendors: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetProcRequisitionDashboard.pending, (state) => {
        return {
          ...state,
          isDashboardLoading: true,
        };
      })
      .addCase(GetProcRequisitionDashboard.fulfilled, (state, action) => {
        return {
          ...state,
          isDashboardLoading: false,
          isSuccessful: true,
          procurementRequisitionDashboard: action.payload,
        };
      })
      .addCase(GetProcRequisitionDashboard.rejected, (state, action) => {
        return {
          ...state,
          isDashboardLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(GetPaymentTerms.pending, (state) => {
        return {
          ...state,
          isLoadingPaymentTerms: true,
        };
      })
      .addCase(GetPaymentTerms.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingPaymentTerms: false,
          isSuccessful: true,
          paymentTerms: action.payload,
        };
      })
      .addCase(GetPaymentTerms.rejected, (state, action) => {
        return {
          ...state,
          isLoadingPaymentTerms: false,
          error: action.payload,
        };
      });
  },
});

export default AppSlice.reducer;
